"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceLineLabel = void 0;
const react_1 = __importDefault(require("react"));
const recharts_1 = require("recharts");
const getTextWidth_1 = require("@/utils/getTextWidth");
const FONT_SIZE = 12;
const PADDING_Y = 10;
const BORDER_WIDTH = 1;
const GAP = 4;
const getCx = (pos, x, width, halfW) => {
    if (pos.includes('Right'))
        return x + width - halfW - GAP;
    if (pos.includes('Left'))
        return x + halfW + GAP;
    if (pos === 'left')
        return x - halfW - GAP;
    if (pos === 'right')
        return x + width + halfW + GAP;
    return x + width / 2;
};
const getCy = (pos, y, height, halfH) => {
    if (pos.includes('Bottom'))
        return y + height - halfH - GAP;
    if (pos.includes('Top'))
        return y + halfH + GAP;
    if (pos === 'top')
        return y - halfH - GAP;
    if (pos === 'bottom')
        return y + height + halfH + GAP;
    return y + height / 2;
};
const computeCenter = (vb, position, halfW, halfH) => {
    const { x = 0, y = 0, width = 0, height = 0 } = vb;
    const pos = String(position);
    return [getCx(pos, x, width, halfW), getCy(pos, y, height, halfH)];
};
const ReferenceLineLabel = ({ viewBox, position, value, color }) => {
    if (!value)
        return null;
    const vb = (viewBox !== null && viewBox !== void 0 ? viewBox : {});
    const rectWidth = (0, getTextWidth_1.getTextWidth)(value, FONT_SIZE);
    const rectHeight = FONT_SIZE + PADDING_Y;
    const [cx, cy] = computeCenter(vb, position, rectWidth / 2, rectHeight / 2);
    return (react_1.default.createElement(recharts_1.ZIndexLayer, { zIndex: 2000 },
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { x: cx - rectWidth / 2, y: cy - rectHeight / 2, width: rectWidth, height: rectHeight, rx: rectHeight / 2, fill: "white", stroke: color, strokeWidth: BORDER_WIDTH }),
            react_1.default.createElement("text", { x: cx, y: cy, textAnchor: "middle", dominantBaseline: "middle", fontSize: FONT_SIZE, fontWeight: "bold", fill: color }, value))));
};
exports.ReferenceLineLabel = ReferenceLineLabel;
